"use client";
import * as React from "react";
const SvgLoginSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.2 3.11 6.08 4.2l2.08 2.02H0v1.56h8.16L6.08 9.8l1.12 1.09 4-3.89zm7.2 9.33H8V14h8V0H8v1.56h6.4z" }));
export {
  SvgLoginSharp as default
};
